<template>
  <div class="am-email-popup">
    <div v-bind:class="{ 'hidden': modalHide }">
    <div class="am-email-title-bar am-main-top-box">
      <span class="am-email-title am-main-top-box-title"><strong>Send Email</strong></span>
    </div>
    <table class="am-email-table">
      <tbody>
      <tr>
        <td><strong><span>From:</span></strong></td>
        <td>
          <input type="text" class="input" v-model="email.from">
        </td>
        <span class="am-asterisk-validation">&nbsp;*</span>
      </tr>
      <tr v-if="policyId">
        <td><strong><span>Company Email:</span></strong></td>
        <td>
          <select v-model="companyEmailId" @change="useCompanyEmail">
            <option :value='0'>- Select Company Email -</option>
            <option v-for="companyEmail in toEmailList" :value="companyEmail.id" :key="companyEmail.id">{{companyEmail.description}}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td><strong><span>To:</span></strong></td>
        <td>
          <input type="text" class="input" v-model="email.to">
        </td>
        <span class="am-asterisk-validation">&nbsp;*</span>
      </tr>
      <tr>
        <td><strong><span>Cc:</span></strong></td>
        <td>
          <input type="text" class="input" v-model="email.cc">
        </td>
        <span class="am-email-bcc" title="Add Bcc"><a @click="displayBcc = !displayBcc">&nbsp;Bcc</a></span>
      </tr>
      <tr v-if="displayBcc">
        <td><strong><span>Bcc:</span></strong></td>
        <td>
          <input type="text" class="input" v-model="email.bcc">
        </td>
        <span class="am-asterisk-validation">&nbsp;*</span>
      </tr>
      <tr>
        <td><strong><span>Subject:</span></strong></td>
        <td>
          <input type="text" class="input" v-model="email.subject">
        </td>
        <span class="am-asterisk-validation">&nbsp;*</span>
      </tr>
      <tr>
        <td><strong><span>Template:</span></strong></td>
        <td>
          <select v-model="email.foreignKeyReference" @change="resetForeignKeyId">
            <option value=''>- Select Template -</option>
            <option v-for="template in templates" :value="template.value" :key="template.value">{{template.name}}</option>
          </select>
        </td>
      </tr>
      <tr v-if="email.foreignKeyReference === 'emailBlast'">
        <td><strong><span>Email Template:</span></strong></td>
        <td>
          <select v-model="email.foreignKeyId" @change="applyTemplate">
            <option :value='0'>- Select Email Template -</option>
            <option v-for="template in emailTemplates" :value="template.id" :key="template.id">{{template.description}}</option>
          </select>
        </td>
      </tr>
      <tr v-if="email.foreignKeyReference === 'customLetter'">
        <td><strong><span>Letter Template:</span></strong></td>
        <td>
          <select v-model="email.foreignKeyId" @change="applyTemplate">
            <option :value='0'>- Select Letter Template -</option>
            <option v-for="template in letterTemplates" :value="template.id" :key="template.id">{{template.title}}</option>
          </select>
        </td>
      </tr>
      <tr v-if="email.foreignKeyReference !== '' && customerId !== 0">
        <td><strong><span>Policy:</span></strong></td>
        <td>
          <select v-model="email.policyId" @change="applyTemplate" :disabled="policyId > 0">
            <option :value='0'>- Select Policy -</option>
            <option v-for="policy in policies" :value="policy.id" :key="policy.id">{{policy.policy}}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td><strong><span>Message:</span></strong></td>
        <td>
          <rich-text-editor v-model="email.body" prefix="some-random-numb"></rich-text-editor>
        </td>
        <span class="am-asterisk-validation">&nbsp;*</span>
      </tr>
      <tr>
        <td></td>
        <td>
          <div><file-upload
            ref="upload"
            :drop="true"
            :multiple="true"
            name="files"
            v-model="files"
            @input-file="inputFile"
            @input-filter="inputFilter"
            :post-action="postURL"
            :data="{email: JSON.stringify(email), files: JSON.stringify(files.length), employeeId: $store.state.auth.user.id}"
            :headers="{Authorization: 'Bearer ' +  authToken}"
          >
          <span class="am-browse-button">
            <button @click.prevent="$refs.upload.active = true" type="button">Browse</button>
          <span>Or drop files here...</span>
          </span>
          </file-upload>
          </div>
          <div v-for="(file, index) in files" class="row" :key="file.name">
            <div class="am-file-box">
              <a href="#">{{file.name}}</a>
              <div><font-awesome-icon class="am-remove-button" icon="times-circle" @click="remove(index)" title="Remove Attachment"/></div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="am-email-blue-border"></div>
    <div class="am-email-align-bottom-buttons">
      <div class="am-email-float-right">
        <button type="button" class="btn btn-primary" :disabled="disableSubmit" @click="afterSubmit">Send</button>
        <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
      </div>
    </div>
    </div>
    <modal name="MessagePopup" classes="am-vue-modal" :clickToClose="false" :pivotY="0.5" :pivotX="0.5" height="auto" width="400px" :adaptive="true">
      <message-popup :errors="messageString" :messageHeader="messageHeader" :isError="isError" @CloseModal="closeModal"></message-popup>
    </modal>
  </div>
</template>

<script>
import api from './../http'
import VueUploadComponent from 'vue-upload-component'
import config from './../config/global.config'
import MessagePopup from './MessagePopup'
import RichTextEditor from './Elements/RichTextEditor'

export default {

  components: {
    MessagePopup,
    VueUploadComponent,
    'rich-text-editor': RichTextEditor
  },

  data () {
    return {
      templates: [
        {
          value: 'emailBlast',
          name: 'Email Template'
        },
        {
          value: 'customLetter',
          name: 'Letter Template'
        }
      ],
      policies: [],
      toEmailList: [],
      errors: [],
      messageString: '',
      messageHeader: '',
      authToken: this.$store.state.auth.token,
      isError: false,
      preloadFlag: false,
      modalHide: false,
      companyEmailId: 0,
      disableSubmit: false,
      displayBcc: false,
      email: {
        messageable_id: 0,
        messageable_type: 'App\\Models\\Employee',
        foreignKeyReference: '',
        foreignKeyId: 0,
        from: '',
        to: '',
        cc: '',
        bcc: '',
        subject: '',
        body: '',
        customerId: 0,
        customerDocsId: 0,
        policyId: 0,
        attachmentIds: 0,
        attachmentType: 'Attachment',
        uploadFilesId: []
      },
      isSent: false,
      postURL: config.apiUrl('email/attachFile'),
      files: [],
      fileCount: 0
    }
  },
  props: {
    to: {
      type: String,
      default: ''
    },
    cc: {
      type: String,
      default: ''
    },
    customerId: {
      type: Number,
      default: 0
    },
    policyId: {
      type: Number,
      default: 0
    },
    // attachment ids separated by a comma
    attachmentIds: {
      type: String,
      default: ''
    },
    // model to which the attachments belong
    attachmentType: {
      type: String,
      default: 'Attachment'
    },
    customerDocsId: {
      type: Number,
      default: 0
    },
    confirmation: {
      type: Boolean,
      default: true
    },
    combine: {
      type: Boolean,
      default: false
    },
    foreignKeyReference: {
      type: String,
      default: ''
    },
    foreignKeyId: {
      type: Number,
      default: 0
    }
  },

  asyncComputed: {
    emailTemplates: {
      get () {
        return api.makeRequest('email/email-blast-templates').then(
          (data) => {
            return data.data.results
          }
        )
      },
      default: []
    },
    letterTemplates: {
      get () {
        return api.makeRequest('email/custom-letter-templates').then(
          (data) => {
            return data.data.results
          }
        )
      },
      default: []
    }
  },

  methods: {
    resetForeignKeyId () {
      this.email.foreignKeyId = 0
      this.applyTemplate()
    },

    submit () {
      this.errors = []
      this.checkForm()
      if (this.errors.length === 0) {
        this.isError = false
        this.disableSubmit = true
        let self = this
        api.postRequest('email/create',
          this.email
        ).then(function (response) {
          let displayMessage = 'Email Sent';
          if("opted out" === response.data.message){
            displayMessage = 'Email not sent to customer as they are opted out'
          }
          self.isSent = true
          if (self.confirmation) {
            self.modalHide = true
            self.messageHeader = 'Confirmation'
            self.messageString = displayMessage
            self.messagePopup()
          } else {
            self.closeModal()
          }
        }).catch(function (error) {
          self.isError = true
          self.messageHeader = 'Error'
          let errorData = error.response.data['Improperly formatted request']
          self.messageString = '<b>Email Failed To Be Sent:</b> \n \n'
          for (var value in errorData) {
            self.messageString += errorData[value] + '\n'
          }
          self.messagePopup()
          self.disableSubmit = false
        })
      } else {
        this.showMessagePopup()
      }
    },

    checkForm () {
        if (this.email.to === '') {
        this.errors.push('To \n')
      }
      if (this.email.from === '') {
        this.errors.push('From \n')
      }
      if (this.email.subject === '') {
        this.errors.push('Subject\n')
      }
      if (this.email.body === '') {
        this.errors.push('Message')
      }
    },

    messagePopup: function () {
      this.$modal.show('MessagePopup')
    },

    applyTemplate () {
      this.setToEmailList()
      if (this.email.foreignKeyId !== 0) {
        switch (this.email.foreignKeyReference) {
          case 'emailBlast':
            this.applyEmailBlast()
            break
          case 'customLetter':
            this.applyCustomLetter()
            break
        }
      } else {
        this.email.subject = ''
        this.email.body = ''
        this.defaultBody()
      }
    },

    defaultBody () {
      let self = this
      api.get(config.applicationUrl(`/ajax/emailBlast.php?default=1`)).then(
        (data) => {
          self.email.body = data.data[0].body
        }
      )
    },

    applyEmailBlast () {
      let self = this
      api.get(config.applicationUrl(`/ajax/emailBlast.php?id=${self.email.foreignKeyId}&customerId=${self.customerId}&policyId=${self.email.policyId}`)).then(
        (data) => {
          self.email.subject = data.data.subject
          self.email.body = data.data.body
        }
      )
    },

    applyCustomLetter () {
      let self = this
      api.get(config.applicationUrl(`/ajax/customLetters.php?id=${self.email.foreignKeyId}&customerId=${self.customerId}&policyId=${self.email.policyId}`)).then(
        (data) => {
          self.email.subject = data.data.subject
          self.email.body = data.data.body
        }
      )
    },

    closeModal () {
      let to = this.email.to.split(',')
      let cc = this.email.cc.split(',')
      let bcc = this.email.bcc.split(',')
      let emails = to.concat(cc, bcc)
      emails = emails.filter(email => email !== '')
      this.$store.dispatch('events/fireEvent', { name: (this.isSent ? 'email-sent' : 'email-not-sent'), data: emails.join(', ') })
      this.$store.dispatch('events/fireEvent', { name: 'email-close', data: null })
    },

    setToEmailList () {
      let policy = this.policies.find(i => i.id === this.email.policyId)
      if (policy) {
        this.toEmailList = policy.product.company.emails
      } else {
        this.toEmailList = []
      }
    },

    useCompanyEmail () {
      this.email.to = (this.companyEmailId === 0) ? '' : this.toEmailList.find(i => i.id === this.companyEmailId).emailAddress
    },

    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        this.email.uploadFilesId.push(newFile.response.results)
        if (newFile.xhr) {
          //  Get the response status code
          console.log('status', newFile.xhr.status)
        }
      }
    },
    /**
       * Pretreatment
       * @param  Object|undefined   newFile   Read and write
       * @param  Object|undefined   oldFile   Read only
       * @param  Function           prevent   Prevent changing
       * @return undefined
       */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf|doc|docx|xls|xlsx|txt)$/i.test(newFile.name)) {
          return prevent()
        }
      }

      // Create a blob field
      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    },

    remove (index) {
      this.$delete(this.files, index)
    },

    afterSubmit () {
      if (this.$refs.upload.files.length === 0) {
        this.submit()
      } else {
        this.errors = []
        this.checkForm()
        this.sendBlankValue()
        if (this.errors.length === 0) {
          this.$refs.upload.active = true
        } else {
          this.showMessagePopup()
        }
      }
    },

    showMessagePopup () {
      this.messageHeader = 'Error'
      this.messageString = '<b>Required Fields:</b>'
      this.messageString = this.messageString + '\n \n' + this.errors.join('')
      this.isError = true
      this.messagePopup()
    },

    // Need to hit the Watcher
    sendBlankValue () {
      let blankArray = {name: ""}
      this.files.push({blankArray})
      this.$delete(this.files, this.files.length-1)
    },

  },

  mounted () {
    this.email.messageable_id = this.$store.state.auth.user.id
    this.email.from = this.$store.state.auth.user.email

    // apply props
    this.email.to = this.to
    this.email.cc = this.cc
    this.email.customerId = this.customerId
    this.email.customerDocsId = this.customerDocsId
    this.email.policyId = this.policyId
    this.email.attachmentIds = this.attachmentIds
    this.email.attachmentType = (this.attachmentType !== '') ? this.attachmentType : this.email.attachmentType
    this.email.combine = this.combine
    this.email.foreignKeyReference = this.foreignKeyReference
    this.email.foreignKeyId = this.foreignKeyId
    this.applyTemplate()

    if (this.email.customerId) {
      let self = this
      api.makeRequest(`customer/${this.email.customerId}/policies`).then(
        (data) => {
          self.policies = data.data.results
          self.setToEmailList()
        }
      )
    }

    if(this.email.attachmentIds) {
      this.preloadFlag = true
        api.postRequest(`email/prefill-attachments`, this.email).then(
          (data) => {
            this.files = data.data.filenames
          }
        )
    }

  },
  watch: {

    'files': {
      handler: function () {
        if (this.$refs.upload && this.$refs.upload.uploaded && this.files.length !== 0 && !this.preloadFlag) {
          this.fileCount = this.files.length
          this.submit()
        }
        this.preloadFlag = false
      },
      deep: true
    }
  }
}

</script>

<style>
  .am-file-box {
    background-color: white;
    border: 1px solid transparent;
    margin: 0 0 4px 14px;
    overflow-y: hidden;
    padding: 4px 4px 4px 8px;
    max-width: 448px;
    min-width: 448px;
  }

  .am-remove-button {
    float: right;
    cursor: pointer;
    margin-top: -15px;
    opacity: .5;
  }

  .am-email-popup {
    width:700px;
    background-color: whitesmoke;
    position: absolute;
    left: -150px;
  }

  .am-email-title-bar {
    height: 33px;
  }

  .am-email-title {
    font-size: 14px;
    color: #FDFEFE;
    float: left;
    margin-top: 4px;
    margin-left: 15px;
  }

  .am-email-table {
    margin-left: 14px;
    margin-right: 40px;
    margin-top: 10px;
  }

  .am-email-table td input{
    width: 500px;
    margin-top: 5px;
    background: white;
  }

  .am-email-table td {
    width: 150px;
  }

  .am-email-table td select {
    width: 500px;
    margin-top: 5px;
    height: 25px;
    background: white;
  }

  .am-email-editor {
    background-color: white;
    margin-top: 5px;
    width: 500px;
  }

  .am-email-editor .ql-editor {
    height: 200px;
  }

  .am-email-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 20px;
  }

  .am-email-align-bottom-buttons button{
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .am-email-float-right {
    margin-left: 535px;
  }

  .am-email-bcc {
    color: #4297d7;
    cursor: pointer;
  }

  .am-asterisk-validation {
    color: #ff0000;
    font-weight: 700;
    font-size: 16px;
  }

  .am-browse-button button{
    margin-top: 5px;
  }

</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
